import { get, post, put, deleted } from "../../index";
import CategoriesRoutes from "./Categories.routes";

const CategoriesServices = {
  getAllCategories: async (search, page, limit, type) => {
    console.log("🚀 ~ getAllCategories: ~ limit:", limit)
    console.log("🚀 ~ getAllCategories: ~ page:", page)
    const result = await get(search == undefined || search == ""
      ? CategoriesRoutes.getAllCategories + `?page=${page}&limit=${limit}&type=${type}`
      : CategoriesRoutes.getAllCategories + `?search=${search}`
    );
    return result;
  },

  uploadImage: async (obj) => {
    const result = await post(CategoriesRoutes.uploadImage, obj);
    return result;
  },

  createCategory: async (obj) => {
    const result = await post(CategoriesRoutes.createCategory, obj);
    return result;
  },

  updateCategory: async (id, obj) => {
    const result = await put(CategoriesRoutes.updateCategory + `/${id}`, obj);
    return result;
  },

  deleteCategory: async (id) => {
    const result = await deleted(CategoriesRoutes.deleteCategory + `/${id}`);
    return result;
  },

  updateCategorySequence: async (obj) => {
    const result = await post(CategoriesRoutes.updateCategorySequence, obj);
    return result;
  },
}

export default CategoriesServices;